import { useEffect, useState } from "react";
import Icon from "../Icon";
import * as api from "../../api";
import { ringClr } from "../../utils";

// «Mis proyectos» en Inicio: los proyectos del gestor nativo en los que la persona es
// miembro y siguen activos. Va ANTES que la tarjeta de Notion: Notion es el segundo
// mundo de proyectos, y quien usa el gestor no veia aqui los suyos.
//
// Se pide aparte (miembro + activo) y no se reutiliza la lista de la pagina Proyectos:
// esa se carga solo al entrar alli, con los filtros que la persona haya puesto.
// Sin permiso o sin red no se pinta ningun error: Inicio no se rompe por esto.
export default function MisProyectos({ currentUser, onAbrir, onVerTodos, card }) {
  const [lista, setLista] = useState(null);   // null = cargando

  useEffect(() => {
    let vivo = true;
    if (!currentUser?.id) return undefined;
    api.getProyectos({ miembro: currentUser.id, estado: "activo" })
      .then(d => { if (vivo) setLista(Array.isArray(d) ? d : []); })
      .catch(() => { if (vivo) setLista([]); });
    return () => { vivo = false; };
  }, [currentUser?.id]);

  return (
    <div style={{ ...card, padding: 16 }}>
      <div style={{ fontWeight: 700, fontSize: 11, color: "var(--text2)", marginBottom: 12,
        textTransform: "uppercase", letterSpacing: ".07em", display: "flex", alignItems: "center", gap: 6 }}>
        <Icon name="kanban-fill" size={13} color="var(--accent)" />Mis proyectos
      </div>
      {lista === null
        ? <p style={{ fontSize: 12, color: "var(--text3)", fontStyle: "italic" }}>Cargando…</p>
        : lista.length === 0
          ? <p style={{ fontSize: 12, color: "var(--text3)", fontStyle: "italic", padding: "8px 0" }}>
              No estás en ningún proyecto activo.
            </p>
          : lista.slice(0, 6).map(p => {
              const avance = Math.round(Number(p.progreso_efectivo) || 0);
              const vencidas = Number(p.vencidas) || 0;
              return (
                <button key={p.id} className="btn" onClick={() => onAbrir(p)}
                  style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", textAlign: "left",
                    padding: "7px 0", background: "none", border: "none", borderBottom: "1px solid var(--border2)",
                    cursor: "pointer", fontFamily: "var(--font)", color: "inherit" }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.name}</div>
                    <div style={{ fontSize: 10, color: vencidas ? "var(--red-text)" : "var(--text3)" }}>
                      {Number(p.completadas) || 0} de {Number(p.tareas) || 0} pasos
                      {vencidas > 0 && ` · ${vencidas} vencido${vencidas === 1 ? "" : "s"}`}
                    </div>
                  </div>
                  <span style={{ fontSize: 11, fontWeight: 700, color: ringClr(avance), flexShrink: 0 }}>{avance}%</span>
                </button>
              );
            })
      }
      {lista !== null && lista.length > 6 && (
        <div style={{ fontSize: 10.5, color: "var(--text3)", marginTop: 6 }}>y {lista.length - 6} más</div>
      )}
      <button className="btn" onClick={onVerTodos}
        style={{ marginTop: 10, width: "100%", padding: "7px", border: "1px dashed var(--border)", borderRadius: 8,
          cursor: "pointer", fontSize: 11, color: "var(--accent)", background: "var(--accent-bg)",
          fontFamily: "var(--font)", display: "flex", alignItems: "center", justifyContent: "center", gap: 5 }}>
        <Icon name="folder2-open" size={11} color="var(--accent)" />Ver todos mis proyectos
      </button>
    </div>
  );
}
